// import React from 'react';
// import { Container, Row, Col, Button, Badge } from 'react-bootstrap';
// import { motion } from 'framer-motion';
// import { FaArrowRight, FaLeaf } from 'react-icons/fa'; // Using react-icons
// import HeroImage from '../../../../assets/img/subscription/tjp_hero_section.png'; 
// const HeroSection = () => {
//   // Custom Colors to match the TJP Brand
//   const colors = {
//     bg: '#FFFBF2', // Light Cream
//     primaryGreen: '#2e7d32', // Deep Nature Green
//     accentOrange: '#e67e22', // Warm Food Orange
//     textDark: '#1a1a1a',
//     textMuted: '#6c757d'
//   };

//   // Animation variants
//   const fadeLeft = {
//     hidden: { opacity: 0, x: -50 },
//     visible: { opacity: 1, x: 0, transition: { duration: 0.8 } }
//   };

//   const fadeRight = {
//     hidden: { opacity: 0, x: 50 },
//     visible: { opacity: 1, x: 0, transition: { duration: 0.8, delay: 0.2 } }
//   };

//   return (
//     <section 
//       style={{ 
//         backgroundColor: colors.bg, 
//         paddingTop: '80px', 
//         paddingBottom: '80px',
//         overflow: 'hidden',
//         position: 'relative'
//       }}
//     >
//       {/* Abstract Background Shape (Optional) */}
//       <div 
//         style={{
//           position: 'absolute',
//           top: '-50px',
//           right: '-50px',
//           width: '400px',
//           height: '400px',
//           backgroundColor: '#ffe0b2', // Light Orange
//           borderRadius: '50%',
//           opacity: 0.3,
//           filter: 'blur(80px)',
//           zIndex: 0
//         }}
//       />

//       <Container className="position-relative" style={{ zIndex: 1 }}>
//         <Row className="align-items-center gy-5">
          
//           {/* --- Left Content --- */}
//           <Col lg={6} md={12}>
//             <motion.div 
//               initial="hidden" 
//               whileInView="visible" 
//               viewport={{ once: true }} 
//               variants={fadeLeft}
//             >
//               {/* Badge */}
//               <Badge 
//                 bg="light" 
//                 text="dark" 
//                 className="mb-3 px-3 py-2 border shadow-sm"
//                 style={{ color: colors.primaryGreen, fontWeight: 600, fontSize: '0.85rem' }}
//               >
//                 <FaLeaf className="me-2" style={{ color: colors.primaryGreen }}/> 
//                 Now Serving in Hyderabad
//               </Badge>

//               {/* Heading */}
//               <h1 className="display-4 fw-bold mb-3" style={{ color: colors.textDark, lineHeight: 1.2 }}>
//                 Healthy Breakfast Combos. <br />
//                 <span style={{ color: colors.accentOrange }}>Smart Subscriptions.</span>
//               </h1>

//               {/* Subheading */}
//               <h4 className="h5 fw-medium mb-3" style={{ color: '#4a4a4a' }}>
//                 Balanced combinations of regular breakfast, healthy porridges, and nourishing soups.
//               </h4>

//               {/* Description */}
//               <p className="lead mb-4" style={{ fontSize: '1.1rem', color: colors.textMuted }}>
//                 Start your day with thoughtfully prepared 2-item and 3-item breakfast combos, 
//                 paired with flexible trial, weekly, and monthly subscription plans — made to fit your routine and health goals.
//               </p>

//               {/* Buttons */}
//               <div className="d-flex flex-wrap gap-3">
//                 <Button 
//                   size="lg" 
//                   className="px-4 py-2 rounded-3 border-0 d-flex align-items-center shadow-sm"
//                   style={{ backgroundColor: colors.primaryGreen }}
//                 >
//                   Explore Combos <FaArrowRight className="ms-2" size={16} />
//                 </Button>

//                 <Button 
//                   variant="outline-success" 
//                   size="lg" 
//                   className="px-4 py-2 rounded-3 bg-white"
//                   style={{ color: colors.primaryGreen, borderColor: colors.primaryGreen }}
//                 >
//                   View Plans
//                 </Button>
//               </div>
//             </motion.div>
//           </Col>

//           {/* --- Right Image --- */}
//           <Col lg={6} md={12}>
//             <motion.div 
//               initial="hidden" 
//               whileInView="visible" 
//               viewport={{ once: true }} 
//               variants={fadeRight}
//               className="position-relative text-center"
//             >
//               {/* Image Container with Style */}
//               <div 
//                 className="shadow-lg"
//                 style={{ 
//                   borderRadius: '30px', 
//                   overflow: 'hidden', 
//                   border: '5px solid white',
//                   transform: 'rotate(2deg)',
//                   transition: 'transform 0.3s ease'
//                 }}
//               >
//                 {/* Use the prompt I gave you to generate a real image, using placeholder for now */}
//                 <img 
//                   src={HeroImage} 
//                   alt="Healthy Breakfast Combo" 
//                   className="img-fluid w-100"
//                   style={{ objectFit: 'cover', height: 'auto' }}
//                 />
//               </div>

//               {/* Floating Card Overlay */}
//               <div 
//                 className="bg-white p-3 rounded-4 shadow position-absolute d-none d-md-flex align-items-center gap-3"
//                 style={{ 
//                   bottom: '30px', 
//                   left: '-20px', 
//                   borderLeft: `5px solid ${colors.accentOrange}`,
//                   minWidth: '200px'
//                 }}
//               >
//                 <div style={{ backgroundColor: '#fff3e0', padding: '10px', borderRadius: '50%' }}>
//                   <span style={{ fontSize: '1.5rem' }}>🥣</span>
//                 </div>
//                 <div className="text-start">
//                   <h6 className="m-0 fw-bold">Freshly Prepared</h6>
//                   <small className="text-muted">Daily before 7 AM</small>
//                 </div>
//               </div>
//             </motion.div>
//           </Col>

//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default HeroSection;

import React from 'react';
import { Container, Row, Col, Button, Badge } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaArrowRight, FaLeaf } from 'react-icons/fa';
import HeroImage from '../../../../assets/img/subscription/tjp_hero_section.png'; 
const HeroSection = () => {
  // Custom Colors - TJP Brand
  const colors = {
    bg: '#FFFBF2',
    creamBg: '#FDF0DD',
    primaryOrange: '#FD7E4B',
    primaryGreen: '#2e7d32',
    textDark: '#1a1a1a',
    textMuted: '#6c757d'
  };

  const fadeLeft = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } }
  };

  const fadeRight = {
    hidden: { opacity: 0, x: 30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6, delay: 0.2 } }
  };

  return (
    <section 
      style={{ 
        backgroundColor: colors.bg, 
        // Logic: 100vh (full screen height) - 70px (approx navbar height)
        minHeight: 'calc(100vh - 70px)', 
        display: 'flex',
        alignItems: 'center', // Centers content vertically
        overflow: 'hidden',
        position: 'relative',
        paddingTop: '20px',    // Reduced from 80px
        paddingBottom: '20px'  // Reduced from 80px
      }}
    >
      {/* Background Shape */}
      <div 
        style={{
          position: 'absolute',
          top: '-10%',
          right: '-10%',
          width: '50vh', // Responsive size based on viewport height
          height: '50vh',
          backgroundColor: '#ffe0b2',
          borderRadius: '50%',
          opacity: 0.3,
          filter: 'blur(60px)',
          zIndex: 0
        }}
      />

      <Container className="position-relative" style={{ zIndex: 1 }}>
        <Row className="align-items-center gy-4"> 
          
          {/* --- Left Content --- */}
          <Col lg={6} md={12}>
            <motion.div 
              initial="hidden" 
              whileInView="visible" 
              viewport={{ once: true }} 
              variants={fadeLeft}
            >
              {/* Badge */}
              <Badge 
                bg="light" 
                text="dark" 
                className="mb-2 px-3 py-2 border shadow-sm"
                style={{ color: colors.primaryGreen, fontWeight: 600, fontSize: '0.75rem' }}
              >
                <FaLeaf className="me-2" style={{ color: colors.primaryGreen }}/> 
                Now Serving in Hyderabad
              </Badge>

              {/* Heading: Changed from display-4 to stricter sizing */}
              <h1 className="fw-bold mb-2" style={{ color: colors.textDark, lineHeight: 1.1, fontSize: 'clamp(2.5rem, 4vw, 3.5rem)' }}>
                Healthy Breakfast Combos. <br />
                <span style={{ color: colors.accentOrange }}>Smart Subscriptions.</span>
              </h1>

              {/* Subheading */}
              <h5 className="fw-medium mb-3 mt-2" style={{ color: '#4a4a4a', fontSize: '1.1rem' }}>
                Balanced combinations of regular breakfast, healthy porridges, and nourishing soups.
              </h5>

              {/* Description */}
              <p className="mb-4" style={{ fontSize: '1rem', color: colors.textMuted, lineHeight: '1.5' }}>
                Start your day with thoughtfully prepared 2-item and 3-item breakfast combos, 
                paired with flexible trial, weekly, and monthly subscription plans.
              </p>

              {/* Buttons */}
              <div className="d-flex flex-wrap gap-3">
                <Button 
                  size="lg" 
                  className="px-4 py-2 rounded-3 border-0 d-flex align-items-center shadow-sm"
                  style={{ backgroundColor: colors.primaryOrange, fontSize: '1rem' }}
                >
                  Explore Combos <FaArrowRight className="ms-2" size={14} />
                </Button>

                <Button 
                  variant="outline-success" 
                  size="lg" 
                  className="px-4 py-2 rounded-3 bg-white"
                  style={{ color: colors.primaryOrange, borderColor: colors.primaryOrange, fontSize: '1rem' }}
                >
                  View Plans
                </Button>
              </div>
            </motion.div>
          </Col>

          {/* --- Right Image --- */}
          <Col lg={6} md={12}>
            <motion.div 
              initial="hidden" 
              whileInView="visible" 
              viewport={{ once: true }} 
              variants={fadeRight}
              className="position-relative text-center d-flex justify-content-center"
            >
              {/* Image Container: Added Max Height constraint */}
              <div 
                className="shadow-lg"
                style={{ 
                  borderRadius: '25px', 
                  overflow: 'hidden', 
                  border: '5px solid white',
                  transform: 'rotate(2deg)',
                  width: '100%',
                  maxWidth: '550px', // Prevents it from getting too wide
                  maxHeight: '450px' // Prevents it from getting too tall
                }}
              >
                <img 
                  src={HeroImage}
                  alt="Healthy Breakfast Combo" 
                  className="img-fluid w-100 h-100"
                  style={{ objectFit: 'cover' }}
                />
              </div>

              {/* Floating Card Overlay */}
              <div 
                className="bg-white p-2 rounded-4 shadow position-absolute d-none d-lg-flex align-items-center gap-3"
                style={{ 
                  bottom: '20px', 
                  left: '10px', 
                  borderLeft: `4px solid ${colors.accentOrange}`,
                  minWidth: '180px'
                }}
              >
                <div style={{ backgroundColor: '#fff3e0', padding: '8px', borderRadius: '50%' }}>
                  <span style={{ fontSize: '1.2rem' }}>🥣</span>
                </div>
                <div className="text-start">
                  <h6 className="m-0 fw-bold" style={{ fontSize: '0.9rem' }}>Freshly Prepared</h6>
                  <small className="text-muted" style={{ fontSize: '0.75rem' }}>Daily before 7 AM</small>
                </div>
              </div>
            </motion.div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;